import { Fragment } from "react";
const Nav = ({theme}) => {
  return (
    <Fragment>
      <div className="nav">
        <div className="container items_center"><img src={theme.logo} alt={theme.title} /></div>
      </div>
    </Fragment>
  );
};

export default Nav;
